module.exports = __webpack_public_path__ + "static/media/angle-down-inputs.8b4e8d2e.svg";